import axios, {
  AxiosInstance,
  InternalAxiosRequestConfig,
  AxiosRequestHeaders,
  AxiosResponse,
  AxiosError
} from 'axios'

import qs from 'qs'

import { config } from './config'

import { ElMessage } from 'element-plus'

import { useCache } from '@/hooks/web/useCache'

const { result_code, base_url } = config

const { wsCache } = useCache()
import router from '@/router'

const createTraceId = () => `trace_${Date.now()}_${Math.random().toString(16).slice(2)}`
const isVisitDataRoute = () => router.currentRoute.value.path.startsWith('/premiss/UserDatas')
const authFailureMessages = [
  'token不能为空',
  '登录已失效',
  '访问令牌无效',
  '访问已失效',
  '访问令牌已过期',
  '登录已超时',
  '用户已离职',
  '用户未启用',
  '当前用户未设置归属组织'
]
const shouldClearLogin = (message = '') => authFailureMessages.some((item) => message.includes(item))

export const PATH_URL = base_url[import.meta.env.VITE_API_BASEPATH]

// 判断连接上有token重新跳转
// const tokenIndex=window.location.href.indexOf('token')
// console.log(tokenIndex,"fffffffff")
// if(tokenIndex!=-1){
// console.log("没有token")
// }else{
//   console.log('有token不需要修改路由地址')
// }
if (wsCache.get('access_token')) {
  axios({
    method:'post',
    url:PATH_URL+'admin/config/company',
    data:{
      token:wsCache.get('access_token')
    },
    headers:{
    }
  }).then(res=>{
    if (res?.data?.code === result_code) {
      wsCache.set('company',res)
    }
  }).catch(() => {})
}

// 创建axios实例
const service: AxiosInstance = axios.create({
  baseURL: PATH_URL, // api 的 base_url
  timeout: config.request_timeout // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    if (
      config.method === 'post' &&
      (config.headers as AxiosRequestHeaders)['Content-Type'] ===
        'application/x-www-form-urlencoded'
    ) {
      config.data = qs.stringify(config.data)
    }
    if (wsCache.get('access_token')) {
      
      (config.headers as AxiosRequestHeaders)['token'] = wsCache.get('access_token')
    }
    const traceId = createTraceId()
    ;(config.headers as AxiosRequestHeaders)['x-trace-id'] = traceId
    ;(config.headers as AxiosRequestHeaders)['_requestId'] = traceId
    if (isVisitDataRoute() && wsCache.get('audit_session_id')) {
      ;(config.headers as AxiosRequestHeaders)['x-audit-session-id'] = wsCache.get('audit_session_id')
    }
    const platform = wsCache.get('company')?.data?.data?.platform
    if(platform){
      (config.headers as AxiosRequestHeaders)['platform'] = platform
    }else{
      // console.log(wsCache.get('access_token'),'asdasdqwe')
    }

    // get参数编码
    if (config.method === 'get' && config.params) {
      let url = config.url as string
      url += '?'
      const keys = Object.keys(config.params)
      for (const key of keys) {
        if (config.params[key] !== void 0 && config.params[key] !== null) {
          url += `${key}=${encodeURIComponent(config.params[key])}&`
        }
      }
      url = url.substring(0, url.length - 1)
      config.params = {}
      config.url = url
    }
    return config
  },
  (error: AxiosError) => {
    // Do something with request error
    return Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  (response: AxiosResponse<any>) => {
    if(response.data.code==3){
      ElMessage.error(response.data.msg)
      if (shouldClearLogin(response.data.msg || '')) {
        wsCache.clear()
        router.push('/login')
      }
    }
    return response.data

    // if (response.config.responseType === 'blob') {
    //   // 如果是文件流，直接过
    //   return response
    // } else if (response.data.code === result_code) {
    //   return response.data
    // } else {
    //   ElMessage.error(response.data.message)
    // }
  },
  (error: AxiosError) => {
    if (!axios.isCancel(error)) {
      ElMessage.error(error.message)
    }
    return Promise.reject(error)
  }
)

export { service }
// import axios, {
//   AxiosInstance,
//   InternalAxiosRequestConfig,
//   AxiosRequestHeaders,
//   AxiosResponse,
//   AxiosError
// } from 'axios'

// import qs from 'qs'

// import { config } from './config'

// import { ElMessage } from 'element-plus'

// import { useCache } from '@/hooks/web/useCache'

// const { result_code, base_url } = config

// const { wsCache } = useCache()

// export const PATH_URL = base_url[import.meta.env.VITE_API_BASEPATH]

// // 创建axios实例
// const service: AxiosInstance = axios.create({
//   baseURL: PATH_URL, // api 的 base_url
//   timeout: config.request_timeout // 请求超时时间
// })

// // request拦截器
// service.interceptors.request.use(
//   (config: InternalAxiosRequestConfig) => {
//     if (
//       config.method === 'post' &&
//       (config.headers as AxiosRequestHeaders)['Content-Type'] ===
//         'application/x-www-form-urlencoded'
//     ) {
//       config.data = qs.stringify(config.data)
//     }
//     if (wsCache.get('access_token')) {
//       ;(config.headers as AxiosRequestHeaders)['Token'] = wsCache.get('access_token')
//     }
//     // get参数编码
//     if (config.method === 'get' && config.params) {
//       let url = config.url as string
//       url += '?'
//       const keys = Object.keys(config.params)
//       for (const key of keys) {
//         if (config.params[key] !== void 0 && config.params[key] !== null) {
//           url += `${key}=${encodeURIComponent(config.params[key])}&`
//         }
//       }
//       url = url.substring(0, url.length - 1)
//       config.params = {}
//       config.url = url
//     }
//     return config
//   },
//   (error: AxiosError) => {
//     // Do something with request error
//     console.log(error) // for debug
//     Promise.reject(error)
//   }
// )

// // response 拦截器
// service.interceptors.response.use(
//   (response: AxiosResponse<any>) => {
//     if (response.config.responseType === 'blob') {
//       // 如果是文件流，直接过
//       return response
//     } else if (response.data.code === result_code) {
//       return response.data
//     } else {
//       ElMessage.error(response.data.message)
//     }
//   },
//   (error: AxiosError) => {
//     console.log('err' + error) // for debug
//     ElMessage.error(error.message)
//     return Promise.reject(error)
//   }
// )

// export { service }
